import { buildProps } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";

export const svgIconProps = buildProps({
  name: {
    type: String,
    required: true,
  },
  size: {
    type: Number,
    default: 24,
  },
  color: {
    type: String,
    default: "#666",
  },
} as const);
export type SvgIconProps = ExtractPropTypes<typeof svgIconProps>;
